module.exports = __webpack_public_path__ + "a31614da78b9ad6eda29958f3fbc1ca6.jpg";